import definition from './labels.service';

/**
 * LabelsApi settings
 * @type {{name: string, definition: LabelsApi}}
 */
export default {
    name: 'LabelsApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/labels/index.js